import Vue from "vue";
import Vuex from "vuex";
import { getStationInfo } from "@/apis";
import { awaitTo } from "@/utils";
import { MAC_KEY, STATION_KEY } from "@/constant";

Vue.use(Vuex);

const rootStore = {
  state: {
    // mac地址
    mac: localStorage.getItem(MAC_KEY),
    // 站点信息
    stationInfo: JSON.parse(localStorage.getItem(STATION_KEY)),
    voice: {
      
    }
  },
  mutations: {
    setMac(state, macId) {
      state.mac = macId;
    },
    setStationInfo(state, payload) {
      state.stationInfo = payload;
    }
  },
  actions: {
    async getStationInfo({ commit }) {
      const [err, res] = await awaitTo(getStationInfo());
      if (!err) {
        commit("setStationInfo", res);
        localStorage.setItem(STATION_KEY, JSON.stringify(res));
      }
    },
    setMacAddress({ commit }, macId) {
      commit("setMac", macId);
      localStorage.setItem(MAC_KEY, macId);
    }
  }
};

const store = new Vuex.Store(rootStore);
export default store;
